import { Box } from "@material-ui/core";
import styles from "./BetaSignUp.module.css";
import Banner from "./Banner";
import InsiderBenefits from "./InsiderBenefits";
import BetaForm from "./BetaForm";
import Footer from "./Footer";

const BetaSignUp: React.FC = () => {
  return <div className={styles.container}>
    <Box
      data-qatag="BetaSignUpContainer"
      className={styles.BetaSignUpContainer}
    >
      <Box data-qatag="BetaSignUpContent" className={styles.BetaSignUpContent}>
        <Banner data-qatag="Banner" />

        <Box data-qatag="formContainer" className={styles.formContainer}>
          <InsiderBenefits data-qatag="insiderBenefits" />
          <BetaForm data-qatag="betaForm" />
        </Box>

        <Footer />
      </Box>
    </Box>
  </div>;
};

export default BetaSignUp;
